import { apiAction } from './api';
import endpoints from './endpoints';
import { getIncidents } from './incidents';
export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';

export const getUser = () => {
  return apiAction({
    url: endpoints.getUser,
    onSuccess: [setUser, getIncidents],
    label: GET_USER,
    showLoading: true,
  });
};

export const setUser = (data) => {
  return {
    type: SET_USER,
    payload: data,
  };
};

const initialState = {
  fullName: '',
  emailAddress: '',
  payType: '',
  timecards: [],
  currentTimecardId: null,
  playlist: [],
};

//reducer
export const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    default:
      return state;
  }
};
